import { parse } from 'cache-parser';
import { Header } from '../util/headers';
export var defaultHeaderInterpreter = function (headers) {
    if (!headers)
        return 'not enough headers';
    var cacheControl = headers[Header.CacheControl];
    if (cacheControl) {
        var _a = parse(cacheControl), noCache = _a.noCache, noStore = _a.noStore, mustRevalidate = _a.mustRevalidate, maxAge = _a.maxAge, immutable = _a.immutable;
        // Header told that this response should not be cached.
        if (noCache || noStore) {
            return 'dont cache';
        }
        if (immutable) {
            // 1 year is sufficient, as Infinity may cause more problems.
            // It might not be the best way, but a year is better than none.
            return 1000 * 60 * 60 * 24 * 365;
        }
        // Already out of date, for cache can be saved, but must be requested again
        if (mustRevalidate) {
            return 0;
        }
        if (maxAge) {
            var age = headers[Header.Age];
            if (!age) {
                return maxAge * 1000;
            }
            return (maxAge - Number(age)) * 1000;
        }
    }
    var expires = headers[Header.Expires];
    if (expires) {
        var milliseconds = Date.parse(expires) - Date.now();
        return milliseconds >= 0 ? milliseconds : 'dont cache';
    }
    return 'not enough headers';
};
